import { render, staticRenderFns } from "./kategorije-vozila.editor.vue?vue&type=template&id=0cbbd9b1&"
import script from "./kategorije-vozila.editor.vue?vue&type=script&lang=ts&"
export * from "./kategorije-vozila.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports